module.exports = __webpack_public_path__ + "static/media/Alex.fbfb9040.png";